// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label {
  margin-top: 20px;
  margin-left: 10px;
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 17px;
  width: 60%;
}

.button {
  margin: 15px;
  width: 110px;
}

.mat-icon {
  margin-bottom: 5px;
}

.top-div {
  display: flex;
  width: 100%;
}

.menu-div {
  text-align: center;
  border-right: 1px solid lightgrey;
}

.doc-div {
  display: inline-block;
  width: 100%;
  margin-right: 15px;
  margin-left: 15px;
}

.edit-button-div {
  text-align: right;
  width: 100%;
}

.header-div {
  display: flex;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImRvY3VtZW50LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsZ0JBQUE7RUFDQSxpQkFBQTtFQUNBLG1CQUFBO0VBQ0EsaUJBQUE7RUFDQSxlQUFBO0VBQ0EsVUFBQTtBQUNGOztBQUVBO0VBQ0UsWUFBQTtFQUNBLFlBQUE7QUFDRjs7QUFFQTtFQUNFLGtCQUFBO0FBQ0Y7O0FBRUE7RUFDRSxhQUFBO0VBQ0EsV0FBQTtBQUNGOztBQUVBO0VBRUUsa0JBQUE7RUFDQSxpQ0FBQTtBQUFGOztBQUdBO0VBQ0UscUJBQUE7RUFDQSxXQUFBO0VBQ0Esa0JBQUE7RUFDQSxpQkFBQTtBQUFGOztBQUdBO0VBQ0UsaUJBQUE7RUFDQSxXQUFBO0FBQUY7O0FBR0E7RUFDRSxhQUFBO0FBQUYiLCJmaWxlIjoiZG9jdW1lbnQuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubGFiZWwge1xuICBtYXJnaW4tdG9wOiAyMHB4O1xuICBtYXJnaW4tbGVmdDogMTBweDtcbiAgbWFyZ2luLWJvdHRvbTogMjBweDtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIGZvbnQtc2l6ZTogMTdweDtcbiAgd2lkdGg6IDYwJTtcbn1cblxuLmJ1dHRvbiB7XG4gIG1hcmdpbjogMTVweDtcbiAgd2lkdGg6IDExMHB4O1xufVxuXG4ubWF0LWljb24ge1xuICBtYXJnaW4tYm90dG9tOiA1cHg7XG59XG5cbi50b3AtZGl2IHtcbiAgZGlzcGxheTogZmxleDtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbi5tZW51LWRpdiB7XG4gIC8vIG1hcmdpbi10b3A6IDMwcHg7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgYm9yZGVyLXJpZ2h0OiAxcHggc29saWQgbGlnaHRncmV5O1xufVxuXG4uZG9jLWRpdiB7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgd2lkdGg6IDEwMCU7XG4gIG1hcmdpbi1yaWdodDogMTVweDtcbiAgbWFyZ2luLWxlZnQ6IDE1cHg7XG59XG5cbi5lZGl0LWJ1dHRvbi1kaXYge1xuICB0ZXh0LWFsaWduOiByaWdodDtcbiAgd2lkdGg6IDEwMCU7XG59XG5cbi5oZWFkZXItZGl2IHtcbiAgZGlzcGxheTogZmxleDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/components/document/document.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;AACF;;AAEA;EACE,YAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;AACF;;AAEA;EAEE,kBAAA;EACA,iCAAA;AAAF;;AAGA;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,WAAA;AAAF;;AAGA;EACE,aAAA;AAAF;AACA,g4CAAg4C","sourcesContent":[".label {\n  margin-top: 20px;\n  margin-left: 10px;\n  margin-bottom: 20px;\n  font-weight: bold;\n  font-size: 17px;\n  width: 60%;\n}\n\n.button {\n  margin: 15px;\n  width: 110px;\n}\n\n.mat-icon {\n  margin-bottom: 5px;\n}\n\n.top-div {\n  display: flex;\n  width: 100%;\n}\n\n.menu-div {\n  // margin-top: 30px;\n  text-align: center;\n  border-right: 1px solid lightgrey;\n}\n\n.doc-div {\n  display: inline-block;\n  width: 100%;\n  margin-right: 15px;\n  margin-left: 15px;\n}\n\n.edit-button-div {\n  text-align: right;\n  width: 100%;\n}\n\n.header-div {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
